import { render, staticRenderFns } from "./medicalhistory.vue?vue&type=template&id=00428239&"
import script from "./medicalhistory.vue?vue&type=script&lang=js&"
export * from "./medicalhistory.vue?vue&type=script&lang=js&"
import style0 from "./medicalhistory.vue?vue&type=style&index=0&id=00428239&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports